<template>
    <form @submit.prevent="review.post(requestUrl, {
        preserveScroll: true,
    })">
        <app-title class="capitalize">Hi {{ user?.name ?? ''}}</app-title>

        <p class="my-4 text-dark">
            Please fill out the form below to submit your review for your <b>{{ website.name }}</b> experience, it would be very much appreciated!
        </p>

        <p v-if="product.type == 'fitter'" class="text-dark">
            There is a separate section to leave any feedback for the fitter, this helps customers decide which fitter to choose when ordering tyres.
        </p>

        <h2 class="mt-4 font-md font-bold">Overall experience</h2>

        <review-rating-comment
            class="mt-4 capitalize"
            type="experience"
            v-model:rating="review.rating"
            v-model:title="review.title"
            v-model:comment="review.comment"
            :errors="review.errors"
        ></review-rating-comment>

        <h2 v-if="reviewType" class="font-md font-bold mt-4">{{ this.productExternalIdentifier ? 'Product review' : (this.fitterIdentifier ? 'Fitter experience' : null) }}</h2>

        <p v-if="externalProduct" class="my-4 text-dark">
            Please fill out the form below to submit your review for your <b>{{ externalProduct.name }}</b>, it would be very much appreciated!
        </p>

        <review-rating-comment
            v-if="this.fitterIdentifier || this.productExternalIdentifier"
            class="mt-4 capitalize"
            :type="reviewType"
            v-model:rating="review.fitterRating"
            v-model:title="review.fitterTitle"
            v-model:comment="review.fitterComment"
            :errors="review.errors"
        ></review-rating-comment>

        <review-question
            v-for="(question, key) of questions"
            :key="key"
            class="mt-4"
            :question="question"
            v-model="review.questions[key].answer"
            :error="review.errors[`questions.${key}.answer`]"
        ></review-question>

        <!-- Only show if we haven't already got user -->
        <template v-if="!user || !user.email || !user.name">
            <app-title class="mt-8" type="subtitle">Your details</app-title>

            <review-user-details
                v-model:username="review.user.name"
                v-model:email="review.user.email"
                v-model:marketing="review.user.marketing"
                :errors="review.errors"
                :type="reviewType"
            ></review-user-details>
        </template>

        <template v-if="website">
            <input-select class="mt-4"
                v-model="review.referred_from"
                :options="referralTypes"
                :placeholder="`Where did you hear about ` + ucwords(website.name) + ' ?'"></input-select>

            <input-error class="mt-1" :error="review.errors.referred_from"></input-error>
        </template>

        <input-recaptcha class="mt-4" v-model="review.recaptcha" ref="recatpcha"></input-recaptcha>

        <input-error class="mt-1" v-if="review.errors.recaptcha">
            {{ review.errors.recaptcha }}
        </input-error>

        <div>
            <app-button type="submit" class="mt-8" :loading="review.processing">Submit your review</app-button>
        </div>
    </form>
</template>
<script>
import InputSelect from "@/Components/Forms/Inputs/InputSelect.vue";
import {useForm, usePage} from "@inertiajs/inertia-vue3";
import AppNavbar from "@/Components/AppNavbar.vue";
import AppTitle from "@/Components/AppTitle.vue";
import ReviewRatingComment from "@/Components/Reviews/Forms/ReviewRatingComment.vue";
import ReviewQuestion from "@/Components/Reviews/Forms/ReviewQuestion.vue";
import ReviewUserDetails from "@/Components/Reviews/Forms/ReviewUserDetails.vue";
import InputError from "@/Components/Forms/Inputs/InputError.vue";
import InputRecaptcha from "@/Components/Forms/Inputs/InputRecaptcha.vue";
import AppButton from "@/Components/AppButton.vue";
import AppPoweredBy from "@/Components/AppPoweredBy.vue";
import AppCard from "@/Components/AppCard.vue";
import Strings from "@/Mixins/Utilities/Strings";

export default {
    mixins: [Strings],
    components: {
        InputSelect,
        AppTitle,
        ReviewRatingComment,
        ReviewQuestion,
        AppNavbar,
        ReviewUserDetails,
        InputRecaptcha,
        AppButton,
        InputError,
        AppPoweredBy,
        AppCard
    },
    props: {
        product: Object,
        externalProduct: Object,
        fitterIdentifier: String,
        productExternalIdentifier: String,
        questions: Array,
        recaptcha: Object,
        website: Object, // The website the user has come from
        user: Object,
        rating: [Number, String],
        requestUrl: {
            type: String,
            default: "/reviews"
        },
        orderReference: String,
        referralTypes: Array
    },
    data() {
        const questions = this.questions.map((question) => {
            return {
                question_id: question.id,
                answer: null,
                required: question.required
            };
        });

        return {
            review: useForm({
                product_id: this.product.id ?? null,
                rating: this.rating ?? 10,
                title: "",
                comment: "",
                fitterRating: this.rating ?? 10,
                fitterTitle: "",
                fitterComment: "",
                fitterIdentifier: this.fitterIdentifier ?? null,
                productExternalIdentifier: this.productExternalIdentifier ?? null,
                website_id: this.website ? this.website.id : null,
                referred_from: null,
                user: {
                    name: this.user?.name ?? "",
                    email: this.user?.email ?? "",
                    marketing: false
                },
                recaptcha: null,
                order_reference: this.orderReference,
                questions: questions,
            })
        }
    },
    computed: {
        siteName() {
            return usePage().props.value.config.name;
        },
        reviewType() {
            console.log(this.fitterIdentifier);
            return this.productExternalIdentifier ? 'product' : (this.fitterIdentifier ? 'fitter' : null);
        }
    }
};
</script>


<style lang="scss" scoped>

</style>
